// import "../styles/DirectorMessage.css";
// import directorImg from "../images/Director.png";

// export default function DirectorMessage() {
//   return (
//     <section className="director-section">

//       <div className="container">

//         <div className="director-wrapper">

//           {/* IMAGE SIDE */}
//           <div className="director-image">

//             <img src={directorImg} alt="Managing Director" />

//             {/* OVERLAPPING NAME TAG */}
//             <div className="director-name-tag">
//               <h4>Mr. Paras Mutha</h4>
//               <span>Managing Director</span>
//             </div>

//           </div>

//           {/* CONTENT SIDE */}
//           <div className="director-content">

//             <span className="director-tag">Director's Message</span>

//             <h2>Commitment Towards Manufacturing Excellence</h2>

//             <p>
//               “At Jat Technocraft Pvt. Ltd., we believe that manufacturing excellence is driven
//               by quality, discipline, and strong process control. Since our establishment in 2015,
//               we have continuously focused on building a robust manufacturing ecosystem aligned with
//               global standards and customer expectations.”
//             </p>

//             <p>
//               “Our organization is equipped with a modern manufacturing setup, certified quality systems,
//               and a dedicated workforce committed to delivering precision in every unit we produce.”
//             </p>

//           </div>

//         </div>

//       </div>

//     </section>
//   );
// }































import "../styles/DirectorMessage.css";
import directorImg from "../images/DemoImage.png";

export default function DirectorMessage() {
  return (
    <section className="director-section">

      <div className="container">

        <div className="director-wrapper">

          {/* IMAGE SIDE */}
          <div className="director-image">

            <img src={directorImg} alt="Managing Director" />

            {/* NAME TAG (BOTTOM RIGHT) */}
            <div className="director-name-tag">
              <h4>Mr. Paras Mutha</h4>
              <span>Managing Director</span>
            </div>

          </div>

          {/* CONTENT SIDE */}
          <div className="director-content">

            {/* MESSAGE TAG (TOP LEFT) */}
            <span className="director-tag">
              Director's Message
            </span>

            <h2>
              Commitment Towards Manufacturing Excellence
            </h2>

            <p>
              “At Jat Technocraft Pvt. Ltd., we believe that manufacturing excellence is driven by
              quality, discipline, and strong process control. Since our establishment in 2015,
              we have continuously focused on building a robust manufacturing ecosystem aligned
              with global standards and customer expectations.”
            </p>

            <p>
              “Our organization is equipped with a modern manufacturing setup, certified quality systems,
              and a dedicated workforce committed to delivering precision in every unit we produce.”
            </p>

          </div>

        </div>

      </div>

    </section>
  );
}